<template>
    <div class="modal is-active">
        <div class="modal-background" @click="toggleModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('suitables.title') }}</p>
                <button class="delete" @click.prevent="toggleModal"></button>
            </header>
            <section class="modal-card-body">
                <ul class="columns is-multiline" style="row-gap: 0.25rem;">
                    <li
                        :key="suitable.id"
                        v-for="suitable in allSuitables"
                        class="column is-half"
                        style="padding-top: 0.25rem; padding-bottom: 0.25rem;"
                    >
                        <label class="checkbox" style="margin-bottom: 0;">
                            <input
                                class="edit-box__inline-input"
                                type="checkbox"
                                :value="suitable.id"
                                v-model="suitables"
                            />
                            {{ suitable.name }}
                        </label>
                    </li>
                </ul>
            </section>


            <footer class="modal-card-foot is-clearfix">
                <a class="button is-primary" @click="saveSuitables">{{ $t('generic.save') }}</a>
                <a class="button" @click="toggleModal">{{ $t('generic.cancel') }}</a>
            </footer>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'suitables',
        props: {
            allSuitables: {
                type: Array,
                default: () => [],
            },
            activeSuitables: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                suitables: [],
            };
        },
        created() {
            this.suitables = this.activeSuitables.map((attribute) => attribute.id);
        },
        methods: {
            toggleModal() {
                this.$emit('toggle-modal');
            },
            saveSuitables() {
                this.$emit('save', this.suitables);
            },
        }
    };
</script>

<style lang="scss" scoped>
.modal-card {
    width: 80%;
    max-width: 800px;
}

.category {
    margin-top: 1.5rem;
}

.attribute {
    padding: 0.25rem 0;
}

.attribute-wrapper {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/suitables/index.vue